import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
    Settings, 
    User, 
    Search,
    Security,
    ArrowDown,
    // ChevronDown,
} from '../../assets/icons';
// import Logo from '../../assets/icons/logo.svg';
import '../../assets/css/layout/admin_header.css';
import RoleSwitcher from '../common/RoleSwitcher';
// import { NavDropdown } from 'react-bootstrap';

const AdminHeader = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    // const location = useLocation();
    
    // States for various dropdowns and features
    const [showUserMenu, setShowUserMenu] = useState(false);
    const [, setShowNotifications] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    // const [isDarkMode, setIsDarkMode] = useState(() => 
    //     localStorage.getItem('theme') === 'dark'
    // );
    // const [notifications] = useState([
    //     {
    //         id: 1,
    //         type: 'user',
    //         title: 'New User Registration',
    //         message: 'John Doe has registered as a farmer',
    //         time: '5 minutes ago',
    //         unread: true
    //     },
    //     {
    //         id: 2,
    //         type: 'case',
    //         title: 'High Priority Case',
    //         message: 'Emergency case reported from Atlantic Farm',
    //         time: '12 minutes ago',
    //         unread: true
    //     },
    //     {
    //         id: 3,
    //         type: 'system',
    //         title: 'System Update',
    //         message: 'Platform maintenance scheduled for tonight',
    //         time: '1 hour ago',
    //         unread: false
    //     }
    // ]);
    
    // Refs for click outside detection
    const userMenuRef = useRef(null);
    const notificationRef = useRef(null);
    const searchRef = useRef(null);
    
    // Get page title based on current route
    // const getPageTitle = () => {
    //     const path = location.pathname;
    //     const titles = {
    //         '/admin': 'Dashboard',
    //         '/admin/users': 'User Management',
    //         '/admin/cases': 'Case Management',
    //         '/admin/farms': 'Farm Management',
    //         '/admin/doctors': 'Doctor Management',
    //         '/admin/labs': 'Lab Management',
    //         '/admin/analytics': 'Analytics',
    //         '/admin/settings': 'Settings',
    //         '/admin/reports': 'Reports'
    //     };
    //     return titles[path] || 'Admin Panel';
    // };
    
    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setShowUserMenu(false);
            }
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setShowNotifications(false);
            }
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    
    // Theme toggle
    // const toggleTheme = () => {
    //     const newTheme = isDarkMode ? 'light' : 'dark';
    //     setIsDarkMode(!isDarkMode);
    //     localStorage.setItem('theme', newTheme);
    //     document.documentElement.setAttribute('data-theme', newTheme);
    // };
    
    // Handle search
    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/admin/search?q=${encodeURIComponent(searchQuery)}`);
            setShowSearch(false);
            setSearchQuery('');
        }
    };
    
    // Handle logout
    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };
    
    // Get unread notification count
    // const unreadCount = notifications.filter(n => n.unread).length;
    
    return (
        <header className="admin-header">
            <div className="header-container">
                {/* Left Section - Logo and Page Title */}
                {/* <div className="header-left">
                    <Link to="/admin" className="admin-logo">
                        <img src={Logo} alt="E-AquaHealth Admin" />
                        <div className="logo-text">
                            <span className="brand-name">E-AquaHealth</span>
                            <span className="admin-badge">
                                <img src={Security} alt="Admin" />
                                Admin
                            </span>
                        </div>
                    </Link>
                    
                    <div className="page-title-section">
                        <div className="breadcrumb-separator">/</div>
                        <h1 className="page-title">{getPageTitle()}</h1>
                    </div>
                </div> */}
                
                {/* Center Section - Search */}
                <div className="header-center">
                    <div className="search-container" ref={searchRef}>
                        <button 
                            className="search-trigger"
                            onClick={() => setShowSearch(!showSearch)}
                        >
                            <img src={Search} alt="Search" />
                            <span>Search...</span>
                            <kbd>Ctrl+K</kbd>
                        </button>
                        
                        {showSearch && (
                            <div className="search-dropdown">
                                <form onSubmit={handleSearch} className="search-form">
                                    <div className="search-input-container">
                                        <img src={Search} alt="Search" />
                                        <input
                                            type="text"
                                            placeholder="Search users, cases, farms..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            autoFocus
                                        />
                                    </div>
                                    <div className="search-suggestions">
                                        <div className="suggestion-category">
                                            <span className="category-label">Quick Actions</span>
                                            <div className="suggestions">
                                                <Link to="/admin/users/add" className="suggestion-item">
                                                    <img src={User} alt="User" />
                                                    Add New User
                                                </Link>
                                                <Link to="/admin/cases" className="suggestion-item">
                                                    <img src={Security} alt="Cases" />
                                                    View All Cases
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}
                    </div>
                </div>
                
                {/* Right Section - Actions and User Menu */}
                <div className="header-right">
                    {/* Role Switcher */}
                    <RoleSwitcher />
                    
                    {/* Theme Toggle */}
                    {/* <button 
                        className="theme-toggle"
                        onClick={toggleTheme}
                        title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
                    >
                        <img src={isDarkMode ? Sun : Moon} alt="Theme" />
                    </button> */}
                    
                    {/* Notifications */}
                    {/* <div className="notification-container" ref={notificationRef}>
                        <button 
                            className="notification-trigger"
                            onClick={() => setShowNotifications(!showNotifications)}
                        >
                            <img src={Bell} alt="Notifications" />
                            {unreadCount > 0 && (
                                <span className="notification-badge">{unreadCount}</span>
                            )}
                        </button>
                        
                        {showNotifications && (
                            <div className="notification-dropdown">
                                <div className="notification-header">
                                    <h3>Notifications</h3>
                                    <span className="notification-count">
                                        {unreadCount} new
                                    </span>
                                </div>
                                
                                <div className="notification-list">
                                    {notifications.map(notification => (
                                        <div 
                                            key={notification.id} 
                                            className={`notification-item ${notification.unread ? 'unread' : ''}`}
                                        >
                                            <div className={`notification-icon ${notification.type}`}>
                                                <img src={
                                                    notification.type === 'user' ? User :
                                                    notification.type === 'case' ? Security :
                                                    Settings
                                                } alt={notification.type} />
                                            </div>
                                            <div className="notification-content">
                                                <h4>{notification.title}</h4>
                                                <p>{notification.message}</p>
                                                <span className="notification-time">
                                                    {notification.time}
                                                </span>
                                            </div>
                                            {notification.unread && (
                                                <div className="unread-indicator"></div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                
                                <div className="notification-footer">
                                    <Link to="/admin/notifications" className="view-all-link">
                                        View All Notifications
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div> */}
                    
                    {/* Settings Quick Access */}
                    {/* <Link to="/admin/settings" className="settings-link" title="Settings">
                        <img src={Settings} alt="Settings" />
                    </Link> */}
                    
                    {/* User Menu */}
                    <div className="user-menu-container" ref={userMenuRef}>
                        <button 
                            className="user-menu-trigger"
                            onClick={() => setShowUserMenu(!showUserMenu)}
                        >
                            {/* <div className="user-avatar">
                                <img 
                                    src={user?.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.first_name + ' ' + user?.last_name)}&background=0f766e&color=ffffff`} 
                                    alt="User Avatar" 
                                />
                                <div className="status-indicator online"></div>
                            </div> */}
                            <div className="user-info">
                                <span className="user-name">
                                    {user?.first_name} {user?.last_name}
                                </span>
                                <span className="user-role">Super Admin</span>
                            </div>
                            <img 
                                src={ArrowDown} 
                                alt="Dropdown" 
                                className={`dropdown-arrow ${showUserMenu ? 'rotated' : ''}`}
                            />
                        </button>
                        
                        {showUserMenu && (
                            <div className="user-dropdown">
                                <div className="dropdown-header">
                                    <div className="user-avatar-large">
                                        <img 
                                            src={user?.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.first_name + ' ' + user?.last_name)}&background=0f766e&color=ffffff`} 
                                            alt="User Avatar" 
                                        />
                                    </div>
                                    <div className="user-details">
                                        <h4>{user?.first_name} {user?.last_name}</h4>
                                        <p>{user?.email}</p>
                                        <span className="role-badge">Super Admin</span>
                                    </div>
                                </div>
                                
                                <div className="dropdown-menu">
                                    <Link to="/admin/profile" className="menu-item">
                                        <img src={User} alt="Profile" />
                                        <span>My Profile</span>
                                    </Link>
                                    <Link to="/admin/settings" className="menu-item">
                                        <img src={Settings} alt="Settings" />
                                        <span>Settings</span>
                                    </Link>
                                    <div className="menu-divider"></div>
                                    <button onClick={handleLogout} className="menu-item logout">
                                        {/* <img src={} alt="Logout" /> */}
                                        <span>Sign Out</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default AdminHeader;